import React from 'react';
import { Col, Offsets, Push, Pull } from 'react-grid-system';

interface Props {
  col?: {
    debug?: boolean;
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
    offset?: Offsets;
    push?: Push;
    pull?: Pull;
    style?: Record<string, unknown>;
  };
}

// eslint-disable-next-line @typescript-eslint/ban-types
const withGrid = <T extends object>(Component: React.ComponentType<T>) =>
  function withCol({ col, ...props }: T & Props) {
    return (
      <Col {...col}>
        <Component {...(props as T)} />
      </Col>
    );
  };

export default withGrid;
